export const Pages = {
  commentingSubmissionGuidelines: { entityId: "3076709" },
  contactUs: { entityId: "800171" },
  epaperEdition: { entityId: "2169615" },
  policiesAndStandards: { entityId: "3074375" },
  privacyPolicy: { entityId: "800172" },
  promotionsTermsConditions: { entityId: "3112977" },
  termsConditions: { entityId: "800173" },
  termsConditions3Month: { entityId: "3160418" },
};
